// src/components/admin/AdminLayout.js
import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f5f5f5;
`;

const Sidebar = styled.div`
  width: 240px;
  background: #fff;
  border-right: 1px solid #eee;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const SidebarHeader = styled.div`
  padding: 20px 16px;
  border-bottom: 1px solid #eee;
  h3 { color: #c8102e; font-size: 0.85rem; margin: 0 0 2px; text-transform: uppercase; letter-spacing: 0.5px; }
  p { color: #333; font-size: 0.95rem; font-weight: 600; margin: 0; }
`;

const NavItem = styled.div`
  padding: 12px 20px;
  cursor: pointer;
  font-size: 0.9rem;
  color: ${p => p.$active ? "#c8102e" : "#444"};
  background: ${p => p.$active ? "#fff5f5" : "transparent"};
  border-left: 3px solid ${p => p.$active ? "#c8102e" : "transparent"};
  font-weight: ${p => p.$active ? "600" : "400"};
  display: flex;
  align-items: center;
  gap: 10px;
  &:hover { background: #fff5f5; color: #c8102e; }
`;

const SubItem = styled(NavItem)`
  padding-left: 40px;
  font-size: 0.85rem;
`;

const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const TopBar = styled.div`
  background: #fff;
  border-bottom: 1px solid #eee;
  padding: 14px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  h2 { margin: 0; font-size: 1.1rem; color: #222; }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.85rem;
  color: #666;
  span { font-weight: 600; color: #333; }
`;

const LogoutBtn = styled.button`
  background: none;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 0.8rem;
  cursor: pointer;
  color: #666;
  &:hover { border-color: #c8102e; color: #c8102e; }
`;

const Content = styled.div`
  padding: 28px;
  flex: 1;
`;

const TIPOS = ["CECAP", "FONE", "APS", "CEC", "CENCAD"];

export default function AdminLayout({ children, titulo }) {
  const navigate = useNavigate();
  const location = useLocation();
  const nombre = localStorage.getItem("admin_nombre") || "Administrador";
  const [certOpen, setCertOpen] = useState(location.pathname.includes("/admin/certificados"));

  const logout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_nombre");
    navigate("/admin");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <Wrapper>
      <Sidebar>
        <SidebarHeader>
          <h3>Panel de Administración</h3>
          <p>Capacitación CNCW</p>
        </SidebarHeader>

        <NavItem $active={isActive("/admin/dashboard")} onClick={() => navigate("/admin/dashboard")}>
          🏠 Dashboard
        </NavItem>

        <NavItem onClick={() => setCertOpen(!certOpen)}>
          📋 Certificados {certOpen ? "▴" : "▾"}
        </NavItem>
        {certOpen && TIPOS.map(tipo => (
          <SubItem
            key={tipo}
            $active={isActive(`/admin/certificados/${tipo}`)}
            onClick={() => navigate(`/admin/certificados/${tipo}`)}
          >
            {tipo}
          </SubItem>
        ))}

        <NavItem $active={isActive("/admin/carga-masiva")} onClick={() => navigate("/admin/carga-masiva")}>
          📤 Carga masiva (Excel)
        </NavItem>

        <NavItem $active={isActive("/admin/fotos")} onClick={() => navigate("/admin/fotos")}>
          🖼️ Carga de fotos
        </NavItem>

        <NavItem $active={isActive("/admin/log")} onClick={() => navigate("/admin/log")}>
          🕐 Log de actividad
        </NavItem>
      </Sidebar>

      <Main>
        <TopBar>
          <h2>{titulo}</h2>
          <UserInfo>
            👤 <span>{nombre}</span>
            <LogoutBtn onClick={logout}>Salir</LogoutBtn>
          </UserInfo>
        </TopBar>
        <Content>{children}</Content>
      </Main>
    </Wrapper>
  );
}